(ns nosco.shared.email-checker
  (:require
   [clojure.string :as string]))

(defn matches-email [maybe-email]
  (when maybe-email
    ;; reject whitespace; while technically whitespace
    ;; is allowed when the local part is quoted, even
    ;; browser type=email will reject spaces, so in practice
    ;; this will catch errors without impacting anyone
    (re-matches #"\S+\@\S+\.\S+" maybe-email)))

(defn normalize-email [email]
  (-> email
      (string/lower-case)
      (string/trim)))
